import { Component } from '@angular/core';
import { TourismEventsComponent } from '@/tourism-events/tourism-events.common';
import { CategoryEvent } from '../tourism-events.model';

@Component({
	selector: 'app-tourism-events-malfunction',
	template: `<app-tourism-events-full [category]="CategoryEvent.MALFUNCTION"></app-tourism-events-full>`,
})
export class TourismEventsMalfunctionComponent extends TourismEventsComponent {
	readonly CategoryEvent = CategoryEvent;
}
